<!-- <link rel="stylesheet" href="weather-widget-main.component.css"> -->
<div id="divWeatherMain" style="height: 300px;">

    @if(weather.data.isDay){
      <div class="weatherWidgetRow">
        <i class="fas fa-3x fa-sun sun"></i>
    </div>
  }
  @if(!weather.data.isDay){
    <div class="weatherWidgetRow">
        <i class="fas fa-3x fa-moon moon"></i>
    </div>
  }
    <div class="weatherWidgetRow cloudDiv">
        <i class="fas fa-cloud fa-3x cloud"></i>
    </div>
    <div class="weatherWidgetRow" style="font-size: 36px;margin-top: 4px;color:yellow;">{{weather.data.currentTime}}</div>
    <div class="weatherWidgetRow" style="font-size: 32px;margin-top: 5px;">{{weather.data.temperature}}°</div>
    <div class="weatherWidgetRow" style="font-size: 16px;">{{weather.data.temperature_min}}° / {{weather.data.temperature_max}}°</div>
    <div class="weatherWidgetRow" style="font-size: 16px;">體感: {{weather.data.feels_like}}°  濕度: {{weather.data.humidity}} 氣壓:{{weather.data.pressure}}</div>
    <div class="weatherWidgetRow" style="font-size: 16px;">風速: {{weather.data.wind_speed}}  風向: {{weather.data.wind_direction}}/{{weather.data.wind_deg}}° 雲量:{{weather.data.clouds}}</div>
    <div class="weatherWidgetRow" style="font-size: 16px;">日出: {{weather.data.sunrise}}  日落: {{weather.data.sunset}}</div>
    <div class="weatherWidgetRow" style="font-size: 16px;margin-top: 1px;">{{weather.data.city}} </div>
    <div class="weatherWidgetRow" style="font-size: 40px;margin-top: 0px;color:yellow">{{weather.data.nowDate}}</div>
</div>
